export default __webpack_public_path__ + "static/media/call_tone.a5dbcd0b.mp3";